import { useReward } from '@/contexts/reward-context';
import { ArrowLeftIcon, ArrowRightIcon, VipLvIcon } from './svg-icons';
import { RankingInfo, RewardScene } from '@/types';
import { EventLayout } from '@/layouts/event-layout';
import { useEffect, useState } from 'react';
import { addCommas, getRankingHiddenName } from '@/utils';

export const RankInfo = () => {
	const { labels, setRewardScene, onKafkaSet, getRankingInfo, id, UserNickName } = useReward();
	const [rankingInfo, setRankingInfo] = useState<RankingInfo[]>();
	const back = () => {
		setRewardScene(RewardScene.Home);
	};
	const gotoWeeklyAwards = () => {
		onKafkaSet({
			type: 2,
			action: 30
		});

		setRewardScene(RewardScene.WeeklyAwards);
	};
	useEffect(() => {
		if (getRankingInfo) {
			getRankingInfo().then((records: RankingInfo[]) => {
				if (records.length > 0) {
					setRankingInfo(records);
				}
			});
		}
	}, []);

	return (
		<EventLayout scene={RewardScene.Ranking}>
			<div className="reward-ranking">
				<div className="reward-ranking__back" onClick={back}>
					<ArrowLeftIcon />
				</div>
				<div className="reward-ranking__content">
					<div className="reward-ranking__info">
						<div className="reward-ranking__title">{labels?.lbl_RPSabaRank}</div>
						<div className="reward-ranking__subtitle">{labels?.lbl_RPExclusiveVIPReward}</div>
						<div className="reward-ranking__text"></div>
						<button className="reward-btn reward-btn--primary" onClick={gotoWeeklyAwards}>
							<div className="reward-btn__info">
								<VipLvIcon />
								<span className="reward-btn__text">{labels?.lbl_RPRewardsOfWeek}</span>
							</div>
							<ArrowRightIcon />
						</button>
					</div>
					<div className="reward-ranking__result">
						<div className="reward-ranking__best">
							<TopThreeRankingSection rankingInfo={rankingInfo} custId={id} index={2} UserNickName={UserNickName} />
							<TopThreeRankingSection rankingInfo={rankingInfo} custId={id} index={1} UserNickName={UserNickName} />
							<TopThreeRankingSection rankingInfo={rankingInfo} custId={id} index={3} UserNickName={UserNickName} />
						</div>

						<ul className="reward-ranking__list">
							<OtherRankingSection rankingInfo={rankingInfo} custId={id} UserNickName={UserNickName} />
						</ul>
					</div>
				</div>
			</div>
		</EventLayout>
	)
};

const TopThreeRankingSection = ({ rankingInfo, custId, index, UserNickName }: { rankingInfo: RankingInfo[] | undefined, custId: number, index: number, UserNickName?: string  }) => {
	if (!rankingInfo) {
		return null;
	}
	const info = rankingInfo[index - 1];
	const isRankingUser= info.CustId === custId;
	return (
		<div className={`reward-ranking__top reward-ranking__top--${index}`}>
			<div className={`reward-badge-rank reward-badge-rank--${index}`} data-highlight={info.CustId === custId}>
				<div className="reward-badge-rank__img"></div>
			</div>

			<div className="reward-ranking__best-info">
				<div className="reward-ranking__result-name">{isRankingUser && UserNickName ? UserNickName : info.NickName? info.NickName : getRankingHiddenName(custId, info)}</div>
				<div className="reward-exp-point">
					<div className="reward-exp-point__icon">
						<i className="reward-iconcolor-exp-star"></i>
					</div>
					<div className="reward-exp-point__text">{addCommas(info.TotalExp)}</div>
				</div>
			</div>
		</div>
	)
}

const OtherRankingSection = ({ rankingInfo, custId, UserNickName }: { rankingInfo: RankingInfo[] | undefined, custId: number, UserNickName?: string }) => {
	if (!rankingInfo) {
		return null;
	}
	return (
		rankingInfo.map((info, index) => {
			const isRankingUser= info.CustId === custId;
			if (index < 3) {
				return null;
			}
			return (
				<li data-focus={isRankingUser} key={`${info.CustId}_${index}`}>
					<div className="reward-ranking__result-name">{isRankingUser && UserNickName ? UserNickName : info.NickName ? info.NickName : getRankingHiddenName(custId, info)}</div>
					<div className="reward-exp-point">
						<div className="reward-exp-point__icon">
							<i className="reward-iconcolor-exp-star"></i>
						</div>
						<div className="reward-exp-point__text">{addCommas(info.TotalExp)}</div>
					</div>
				</li>
			)
		})
	);
}